export default "__VITE_ASSET__BwOetJir__"